import Loading from "@/components/Loading/Loading"
import { usePublicTopOneAchievement } from "@/queries/queries"
import html2canvas from "html2canvas"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { FaDownload, FaUserAlt } from "react-icons/fa"
import { useParams } from "react-router-dom"

export default function TopOneShare() {
  const { id } = useParams()
  const achievementQuery = usePublicTopOneAchievement(Number(id))
  const { t } = useTranslation()
  const [isDefaultImage, setIsDefaultImage] = useState(false)

  const handleDownload = async () => {
    const element = document.getElementById("achievement-card")
    if (!element) return

    const canvas = await html2canvas(element, {
      useCORS: true,
      scale: 2,
      backgroundColor: null,
    })

    const image = canvas.toDataURL("image/png")
    const link = document.createElement("a")
    link.download = `achievement-${achievementQuery.data?.user.name}.png`
    link.href = image
    link.click()
  }

  if (achievementQuery.isLoading) return <Loading />
  if (!achievementQuery.data)
    return <div>{t("topOneShare.notFound", "Achievement not found")}</div>

  const achievement = achievementQuery.data

  return (
    <div className="min-vh-100 d-flex flex-column align-items-center justify-content-center p-4 bg-light">
      <div
        id="achievement-card"
        className="position-relative overflow-hidden shadow-lg p-5 text-center d-flex flex-column align-items-center"
        style={{
          width: "600px",
          background: "linear-gradient(135deg, #243b78 0%, #3a5ba0 100%)",
          borderRadius: "30px",
          color: "white",
        }}
      >
        {/* Background Decoration */}
        <div
          style={{
            position: "absolute",
            top: "-50px",
            right: "-50px",
            width: "200px",
            height: "200px",
            background: "rgba(255, 215, 0, 0.1)",
            borderRadius: "50%",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: "-50px",
            left: "-50px",
            width: "150px",
            height: "150px",
            background: "rgba(255, 215, 0, 0.05)",
            borderRadius: "50%",
          }}
        />

        <div className="mb-4">
          <span style={{ fontSize: "80px" }}>🏆</span>
        </div>

        <h1 className="fw-bold mb-2" style={{ color: "#ffd700" }}>
          {t("topOneShare.title", "Top One Achievement")}
        </h1>
        <p className="opacity-75 mb-5 fs-5">
          {t("topOneShare.academy", "EraaSoft Academy")}
        </p>

        <div
          className="mb-4"
          style={{
            width: "150px",
            height: "150px",
            borderRadius: "50%",
            overflow: "hidden",
            border: "5px solid #ffd700",
            boxShadow: "0 0 20px rgba(255, 215, 0, 0.5)",
            backgroundColor: "rgba(255, 255, 255, 0.1)",
          }}
        >
          {isDefaultImage || !achievement.user.image ? (
            <div className="h-100 d-flex align-items-center justify-content-center">
              <FaUserAlt size={60} color="rgba(255,255,255,0.8)" />
            </div>
          ) : (
            <img
              src={achievement.user.image}
              alt={achievement.user.name}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              crossOrigin="anonymous"
              onError={() => setIsDefaultImage(true)}
            />
          )}
        </div>

        <h2 className="fw-bold mb-4">{achievement.user.name}</h2>

        <div
          className="p-3 w-100"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            borderRadius: "15px",
            border: "1px solid rgba(255, 255, 255, 0.2)",
          }}
        >
          <div className="row g-0">
            <div className="col-6 border-end border-white border-opacity-25">
              <p className="small opacity-75 mb-1 text-uppercase">
                {t("topOneShare.course", "Course")}
              </p>
              <p className="fw-bold mb-0">{achievement.course?.title}</p>
            </div>
            <div className="col-6">
              <p className="small opacity-75 mb-1 text-uppercase">
                {t("topOneShare.round", "Round")}
              </p>
              <p className="fw-bold mb-0">{achievement.round?.name}</p>
            </div>
          </div>
        </div>

        <div className="mt-5 opacity-50 small">
          {t("topOneShare.verifiedBy", "Verified by EraaSoft")}
        </div>
      </div>

      <div className="mt-4">
        <button
          onClick={handleDownload}
          className="btn btn-primary btn-lg d-flex align-items-center gap-2"
          style={{ borderRadius: "10px" }}
        >
          <FaDownload /> {t("buttons.download", "Download as Image")}
        </button>
      </div>
    </div>
  )
}
